export default "__VITE_ASSET__D$Fc2gR3__"